import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { Section } from './Section';
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from '../data/config';
const STATS = [{
  value: '17 años',
  label: 'de experiencia en tecnología'
}, {
  value: '+8.500',
  label: 'equipos Apple vendidos'
}, {
  value: '+180.000',
  label: 'seguidores en Instagram'
}];
export function AboutAuthor() {
  return <Section className="bg-ink-900" innerClassName="max-w-5xl" data-id="element-23" data-mp="109xt26ww4io3">
      <div className="grid items-center gap-10 lg:grid-cols-2" data-id="element-24" data-mp="10caamiyqkr0m">
        <img src="https://cdn.magicpatterns.com/uploads/8Vu6HJx32p33t8e462HhiY/ChatGPT_Image_27_jul_2026,_05_53_28_p.m..png" alt="Marcio Gómez sosteniendo la guía Diccionario Apple" className="w-full rounded-3xl border border-white/10 object-cover" data-id="element-25" data-mp="vc4nng3evsov" />
        <div data-id="element-26" data-mp="2kp9ilnem0tjj">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-27" data-mp="2koq127svg761">Quién está detrás</p>
          <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-28" data-mp="2go67fe7iblon">
            Celulares Nuevos Saavedra, por Marcio Gómez
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-29" data-mp="31hs8gn9971de">
            Detrás de Diccionario Apple está Celulares Nuevos Saavedra, una de las marcas de venta de productos Apple más
            grandes de Argentina, con más de 180.000 seguidores en Instagram. Marcio Gómez, su fundador, es especialista
            en el ecosistema Apple, con 17 años de experiencia en tecnología y más de 8.500 equipos Apple vendidos. Todo
            ese conocimiento práctico hoy está reunido en esta guía, creada para que cualquier persona aprenda a usar su
            iPhone como un experto.
          </p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-30" data-mp="2rmi967a8p83b">
            <InstagramIcon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-31" data-mp="2xfnqk1i1nz86" />
            {INSTAGRAM_HANDLE}
          </a>
          <dl className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-32" data-mp="3b9yeigm7vpd6">
            {STATS.map(stat => <div key={stat.value} className="rounded-2xl border border-white/8 bg-ink-950/70 p-4" data-id="element-33" data-mp="378d18u5rt92g">
                <dt className="text-xl font-extrabold tracking-tight text-accent-soft" data-id="element-34" data-mp="2jis9pmvjx3hk">{stat.value}</dt>
                <dd className="mt-1 text-xs leading-relaxed text-white/55" data-id="element-35" data-mp="2ejxs2o9blkz1">{stat.label}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </Section>;
}